import React, { useCallback, useRef, useState } from "react"
import ViewShot from "~/ui/ViewShot"
import styled, { useTheme } from "~/ui/styled"
import useMediaLibrary from "~hooks/useMediaLibrary"
import { alertError } from "~utils/alert"
import { Qrcode } from "~components/qrcode"
import { Avatar } from "~widgets/avatar"
// import { AvatarWrapperTypes, AvatarSizes } from "~widgets/avatar/types"
import { Text, Button, CenterFlex, ColumnCenterFlex, BetweenFlex } from "~components/El"
import { usePopup } from "~hooks/usePopup"

const Container = styled.View`
  position: relative;
  width: 100%;
  min-height: 500px;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  border-radius: 12px;
  overflow: hidden;
`

const QrcodeCard: React.FC<any> = ({ user }) => {
  const theme = useTheme()
  const { avatar, contactName, name, qrcode, isDownload, isShare, id, username } = user
  // console.log(user, '--user--')
  const ref = useRef<any>()
  const [loading, setLoading] = useState(false)
  const { saveAssetAsync, requestPermissionsAsyncWithCallback } = useMediaLibrary({ writeOnly: true })
  const getShotUri = useCallback(() => {
    return new Promise<string>((resolve) => {
      ref.current.capture().then((uri) => {
        resolve(uri)
      })
    })
  }, [])
  const saveQrcode = useCallback(() => {
    if (loading) return
    async function save() {
      try {
        setLoading(true)
        const uri = await getShotUri()
        await saveAssetAsync({ uri })
      } catch (e) {
        alertError(e)
      } finally {
        setLoading(false)
      }
    }
    requestPermissionsAsyncWithCallback({
      callback: save,
    })
  }, [loading, getShotUri, requestPermissionsAsyncWithCallback, saveAssetAsync])
  const popup = usePopup()
  return (
    <Container>
      <ViewShot
        ref={ref}
        options={{
          fileName: `chat-qrcode-${Date.now()}`,
          format: "png",
          quality: 1.0,
        }}
      >
        <ColumnCenterFlex width="100%" bg={theme.colors.blockBackground}>
          <CenterFlex width="100%" height="50px" padding="0 15px">
            <Text color="text" fontWeight="600" fontSize={"20px"}>
              我的二维码
            </Text>
          </CenterFlex>
          <Avatar
            size={60}
            avatar={avatar}
            name={name}
          />
          <Text color={"text"} fontSize={"20px"} fontWeight="600" mt="5px">
            {contactName || name}
          </Text>
          <Text color={"secondaryText"} fontSize={"12px"}>
            ID：{username}
          </Text>
          <Qrcode
            value={qrcode}
            avatar={avatar}
            name={name}
            description={"扫一扫上面的二维码，加我为好友"}
            isDownload={isDownload}
            isShare={isShare}
          />
        </ColumnCenterFlex>
      </ViewShot>
      <BetweenFlex gap="10px" width="100%" padding="15px">
        <Button
          flex={1}
          bg="background"
          borderRadius="10px"
          height="40px"
          onClick={() => {
            popup?.close()
          }}
        >
          <Text color="secondaryText">关闭</Text>
        </Button>
        <Button
          flex={1}
          bg="buttonBackground"
          borderRadius="10px"
          height="40px"
          onClick={saveQrcode}
        >
          <Text color="#fff" fontWeight="600">
            保存二维码
          </Text>
        </Button>
      </BetweenFlex>
    </Container>
  )
}

export default QrcodeCard
